import { init } from '@rematch/core'
import { useDispatch as useReduxDispatch } from 'react-redux'

import { user } from './models/user'
import { ExtractRootState, ExtractRootDispatch } from './utilTypes'

const models = {
  user,
}

export const store = init({
  models,
})

type AllModels = typeof models

export type Store = typeof store
export type Dispatch = ExtractRootDispatch<AllModels>
export type iRootState = ExtractRootState<AllModels>

export const useDispatch = () => useReduxDispatch<Dispatch>()
